import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { DatePipe } from '@angular/common';
import { date } from '@rxweb/reactive-form-validators';
import { catchError, retry, shareReplay } from 'rxjs/operators';
import axios from 'axios';
@Injectable({
  providedIn: 'root'
})
export class BrdsqlService {

  supcodeNow: string = "";
  supzoneNow: string = "";
  yearNow: string = ""
  datenow: any = new Date();
  hurl = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/';
  baseSelectUrl = `${this.hurl}dbcps/select_s_f_w?`
  baseSelectUrl2 = `${this.hurl}dbcps/select_s_f_w_0?`
  baseSelectUrl3 = `${this.hurl}dbbrr/select_s_f_w_0?`
  baseUpdateUrl = `${this.hurl}dbcps/update_t_s_w?`
  baseInsertUrl = `${this.hurl}dbcps/insert_t_c_v?`
  private cachedSearchRegtruckData$: Observable<any> | null = null;
  private cachedProductionYearData$: Observable<any> | null = null;
  private cachedbrdCPCData$: Observable<any> | null = null;
  private cachedCanequalityData$: Observable<any> | null = null;

  yearID: any = [
    { yearlb: '64/65', yearTh: '6465', yearCr: '2122' },
    { yearlb: '65/66', yearTh: '6566', yearCr: '2223' },
    { yearlb: '66/67', yearTh: '6667', yearCr: '2324' },
    { yearlb: '67/68', yearTh: '6768', yearCr: '2425' },
    { yearlb: '68/69', yearTh: '6869', yearCr: '2526' },
    { yearlb: '69/70', yearTh: '6970', yearCr: '2627' },
  ];
  supzone: any = [
    { supzone: "01", zone_id: "01", zonename: "โรงงาน" },
    { supzone: "02", zone_id: "02", zonename: "หนองเครือ" },
    { supzone: "03", zone_id: "03", zonename: "โนนเขวา" },
    { supzone: "04", zone_id: "04", zonename: "ละกอ" },
    { supzone: "05", zone_id: "05", zonename: "ลำทะเมนชัย" },
    { supzone: "06.1", zone_id: "06.1", zonename: "นาสีนวล" },
    { supzone: "06.2", zone_id: "06.2", zonename: "ตลาดโพธิ์" },
    { supzone: "07.1", zone_id: "07.1", zonename: "หนองไผ่" },
    { supzone: "07.2", zone_id: "07.2", zonename: "สวายตางวน" },
    { supzone: "08.1", zone_id: "08.1", zonename: "โนนจำปา" },
    { supzone: "08.2", zone_id: "08.2", zonename: "ทุ่งวัง" },
    { supzone: "09", zone_id: "09", zonename: "ตลาดชัย" },
    { supzone: "10.1", zone_id: "10.1", zonename: "ปลัดปุ๊ก" },
    { supzone: "10.2", zone_id: "10.2", zonename: "บ้านด่าน" }
  ];
  supzoneAll: any[] = [
    { supzone: "01", zone_id: "010", zonename: "โรงงาน" },
    { supzone: "02", zone_id: "020", zonename: "หนองเครือ" },
    { supzone: "03", zone_id: "030", zonename: "โนนเขวา" },
    { supzone: "04", zone_id: "040", zonename: "ละกอ" },
    { supzone: "05", zone_id: "050", zonename: "ลำทะเมนชัย" },
    { supzone: "06.1", zone_id: "061", zonename: "นาสีนวล" },
    { supzone: "06.2", zone_id: "062", zonename: "ตลาดโพธิ์" },
    { supzone: "07.1", zone_id: "071", zonename: "หนองไผ่" },
    { supzone: "07.2", zone_id: "072", zonename: "สวายตางวน" },
    { supzone: "08.1", zone_id: "081", zonename: "โนนจำปา" },
    { supzone: "08.2", zone_id: "082", zonename: "ทุ่งวัง" },
    { supzone: "09", zone_id: "090", zonename: "ตลาดชัย" },
    { supzone: "10.1", zone_id: "101", zonename: "ปลัดปุ๊ก" },
    { supzone: "10.2", zone_id: "102", zonename: "บ้านด่าน" },
    { supzone: "21", zone_id: "210", zonename: "โซน21" },
    { supzone: "22", zone_id: "220", zonename: "โซน22" },
    { supzone: "23", zone_id: "230", zonename: "โซน23" }
  ];
  canetype = [
    { code: "ER", name: "ปลายฝน" },
    { code: "SR", name: "ต้นฝน" },
    { code: "ST1", name: "ตอ 1" },
    { code: "ST2", name: "ตอ 2" },
    { code: "ST3", name: "ตอ 3" },
    { code: "ST>", name: "> ตอ3" },
    { code: "CL", name: "แปลงเสียหาย" },
    { code: "OT", name: "ยกเลิกมีเบิกปัจจัย" }
  ];
  sumZonne = [
    ["", "", "", "*** ทุกโซน ***"],
    ["P1", "05", "sum", "* รวมโซน 05 *"],
    ["P1", "06.1", "sum", "* รวมโซน 06.1 *"],
    ["P1", "06.2", "sum", "* รวมโซน 06.2 *"],
    ["P1", "09", "sum", "* รวมโซน 09 *"],

    ["P3", "08.1", "sum", "* รวมโซน 08.1 *"],
    ["P3", "08.2", "sum", "* รวมโซน 08.2 *"],

    ["P3", "07.1", "sum", "* รวมโซน 07.1 *"],
    ["P3", "07.2", "sum", "* รวมโซน 07.2 *"],

    ["P4", "01", "sum", "* รวมโซน 01 *"],
    ["P4", "02", "sum", "* รวมโซน 02 *"],

    ["P5", "03", "sum", "* รวมโซน 03 *"],
    ["P5", "04", "sum", "* รวมโซน 04 *"],
    ["P5", "10.1", "sum", "* รวมโซน 10.1 *"],
    ["P5", "10.2", "sum", "* รวมโซน 10.2 *"],

    ["P1", "sum", "sum", "** รวมส่วน P1 **"],
    ["P2", "sum", "sum", "** รวมส่วน P2 **"],
    ["P3", "sum", "sum", "** รวมส่วน P3 **"],
    ["P4", "sum", "sum", "** รวมส่วน P4 **"],
    ["P5", "sum", "sum", "** รวมส่วน P5 **"],
    ["", "", "", "*** ทุกโซน ***"],
  ];

  constructor(private http: HttpClient) {
    this.supcodeNow = localStorage.getItem('supcode')
    this.supzoneNow = localStorage.getItem('supzone')
    this.yearNow = localStorage.getItem('yearCr')
    // if(localStorage.getItem('yearid')) {this.yearCr='2223'; this.yearTh = '6566'};
  }

  // ข้อมูลออดิตตามรหัสผู้ออดิต
  getAuditData(yearid: string, supzone: string): Observable<any[]> {
    let auditDataUrl = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/select_vw_audit_true_w?yearid=" + yearid + "&supzone=" + supzone;
    return this.http.get<any[]>(auditDataUrl);
  };

  // อัพเดต ข้อมูล รายการออดิต
  updateAudit(f: any) {
    const datepipe: DatePipe = new DatePipe('en-US')
    let formattedDate = datepipe.transform(this.datenow, 'YYYY-MMM-dd')
    console.log('date: ', formattedDate)
    // this.datenow = this.datePipe.transform(this.datenow, 'yyyy-MM-dd');
    let updateAuditUrl = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_audit_w?DataId=" + f.dataid + "&status_sv=3&Comment_2=" + f.Comment_2 + "&date_2=" + formattedDate + "&Comment_2_imgurl=" + f.Comment_2_imgurl;
    console.log('update url:', updateAuditUrl)
    return this.http.get<any[]>(updateAuditUrl);
  }

  // ข้อมูลการแจ้งเตือน รายการจากออดิต ที่ ผจก.ต้องดำเนินการตรวจสอบแก้ไข
  alertFromAudit(yearid: string, supzone: string): Observable<any[]> {
    if (!yearid) { yearid = '2223' };
    let Url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[vw_audit_true]&w=yearid='"
      + yearid + "' and supzone='" + supzone + "'" + " and status_sv='3' ";
    // console.log('url in brdservice: ',Url);
    return this.http.get<any[]>(Url);
  };

  // ข้อมูลแปลงขอปุ๋ยรอบ3 ได้ของชาวไร่
  fmgetFactor(fmcode: string): Observable<any[]> {
    let Url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[v_getfactor6566]&w=fmcode='" + fmcode + "'" + " order by datepost desc ";
    // console.log('url in brdservice: ',Url);
    return this.http.get<any[]>(Url);
  };

  // ข้อมูลการเบิกปัจจัยการผลิตของชาวไร่ ในปีการผลิต
  cpGetfert3(fmcode: string): Observable<any[]> {
    let Url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[v_cp6566_getFert3]&w=fmcode='" + fmcode + "'" + " order by supzone,intlandno ";
    // console.log('url in brdservice: ',Url);
    return this.http.get<any[]>(Url);
  };

  // สูตรปุ๋ย
  chemicalList(): Observable<any[]> {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_stock_w?group_type=1";
    return this.http.get<any[]>(url);
  }

  // เพิ่มข้อมูล การขอปุ๋ยรอบ3
  addChemical3(f: any): Observable<any[]> {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/insert_getfactorw?supcode='"
      + f.hsupcode + "'&factor_type=2&itid='" + f.hitid + "'&intlandno='" + f.hintlandno + "'&fmcode='" + f.hfmcode +
      "'&YearID='6566'&stockid='" + f.stockid + "'&doc_status=8&get1='" + f.get1 + "'&amt1=" + f.amt1 +
      "&take_method='" + f.take_method + "'&getFert3='Y'";
    return this.http.get<any[]>(url);
  }


  // เพิ่มข้อมูล นักส่งเสริมคีย์ตรวจพบ โรค / แมลง
  insertInsect(f: any): Observable<any[]> {
    let supcode = localStorage.getItem('supcode');
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/insert_t_c_v?t=[CPS6263].[dbo].[isDisease_insect]&c=[yearid] ,[itid],[surveyDay] ,[insect_disease_by],[Comment_1],[is_Disease],[pc_Disease],[is_insect],[pc_insect],[parasitic_wasps]&v=" + "'" + f.yearid + "','" + f.itid + "','" + f.surveyDay + "','" + supcode + "','" + f.Comment_1 + "'," + f.disease + "," + f.pc_disease + "," + f.insect + "," + f.pc_insect + "," + f.parasitic_wasps
    console.log('url ', url)
    return this.http.get<any[]>(url);
  }

  // โหลดข้อมูลแปลงอ้อย ของชาวไร่ ตาม fmcode และ year
  listPlotFm(fmcode: string) {
    let yearid = localStorage.getItem('yearCr');
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=itid,intlandno,year,fmcode,canetype,landvalue,credit_amount,money_amt,(credit_amount-money_amt) credit_left&f=[CPS6263].[dbo].[v_cp_data]&w=year=" + yearid + " and fmcode=" + fmcode + " order by intlandno";
    // console.log('url ' ,url)
    return this.http.get<any[]>(url);
  }

  // โหลดข้อมูลแปลงอ้อย ของชาวไร่ ตาม fmcode และ year
  listCpFm(yearid: string, fmcode: string) {
    let url = this.baseSelectUrl
      + "&s=*"
      + "&f=cps6263.dbo.v_cp_data"
      + "&w=year='" + yearid + "' and fmcode ='" + fmcode + "' order by intlandno"
    // console.log('url ' ,url)
    return this.http.get<any[]>(url);
  }

  // ข้อมูลแปลงอ้อย db sql ชาวไร่
  getCpFm(year: any, fmcode: string): Observable<any[]> {
    const url = this.baseSelectUrl
      + "s=*"
      + "&f=CPS6263.dbo.v_cp_data&w=year=" + year + " and fmcode='" + fmcode
      + "' order by intlandno"
    // console.log('getCpFm url', url)
    return this.http.get<any[]>(url)
  }

  // ข้อมูลแปลงอ้อยทั้งหมดของปี db sql
  getCpAll(year: any): Observable<any[]> {
    const url = this.baseSelectUrl
      + "s=itid,intlandno,fmcode,fmname,landvalue,canetype,groupcode,supcode,supzone,partcode,seedcode,gradenow,ton,assess,cutstatus,arealevel"
      + "&f=CPS6263.dbo.v_cp_data&w=year='" + year
      + "' order by intlandno"
    return this.http.get<any[]>(url)
  }

  // update วิธีการจัดการกับโรคแมลงของนักส่งเสริม
  updateInsect(f: any) {
    const datepipe: DatePipe = new DatePipe('en-US')
    let date_1 = datepipe.transform(this.datenow, 'YYYY-MMM-dd')
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_isDisease_insect_w?[DataId]=" + f.DataId + "&[status_sv]=1&[Comment_1]=" + f.Comment_1 + "&[date_1]=" + date_1 + " ";
    console.log('url ', url);
    return this.http.get<any[]>(url);
  }

  // supzone BRD
  getSupzone() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=supzone,zonename&f=[CPS6263].[dbo].[supzone]&w=supzone between '01' and '10.2' order by supzone ";
    return this.http.get<any[]>(url);
  }

  // StockBRD
  getStockBRD() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_StockBRD";
    return this.http.get<any[]>(url);
  }

  // โหลดข้อมูลโรคแมลง ของ นักส่งเสริม
  getDatainsect(yearid: string, supcode: string) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[v_isDisease_insect]&w=yearid='" + yearid + "' and insect_disease_by='" + supcode + "' order by daterec desc";
    // console.log('url ',url);
    return this.http.get<any[]>(url);
  }

  // โหลดข้อมูลแปลงอ้อย ของ นักส่งเสริม
  getCpsupcode(yearid: string, supcode: string) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=itid,intlandno,fmname,canetype,landvalue,route,supzone&f=[CPS6263].[dbo].[v_cp" + yearid + "_basic]&w=supcode=" + supcode + " order by intlandno";
    // console.log('url ' ,url)
    return this.http.get<any[]>(url);
  }

  // โหลดข้อมูลแปลงอ้อย ของโซน
  getCpsupzone(yearid: string, supzone: string) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=itid,intlandno,fmname,CaneTypeName,landvalue,route,supzone&f=[CPS6263].[dbo].[v_cp" + yearid + "_basic]&w=supzone='" + supzone + "' order by intlandno";
    // console.log('url ' ,url)
    return this.http.get<any[]>(url);
  }

  // โหลดข้อมูลแปลงอ้อย ตาม itid
  getCpbyItid(itid: string) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[v_cp_data]&w=itid='" + itid + "'";
    // console.log('url ' ,url)
    return this.http.get<any[]>(url);
  }

  // โหลดข้อมูลการแก้ไขแปลงอ้อย ตาม edit_id
  getEditInfo(edit_id: string) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[v_editDataCP]&w=edit_id='" + edit_id + "'";
    // console.log('url ' ,url)
    return this.http.get<any[]>(url);
  }

  // ข้อมูลการเบิกเกี้ยวของแปลงอ้อย
  getCpFinance(yearid: string, itid: string) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=docid,yearid,itid,intlandno,fmcode,datepost,money_amt,comment1,docdesc&f=[CPS6263].[dbo].[v_getfinance" + yearid + "]&w=itid='" + itid + "' order by datepost desc";
    // console.log('url ' ,url)
    return this.http.get<any[]>(url);
  }

  // ข้อมูลการเบิกปัจจัยการผลิตของแปลงอ้อย
  getCpFactor(yearid: string, itid: string) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=docid,datepost,yearid,intlandno,desc1,amt1,desc2,amt2,desc3,amt3,desc4,amt4&f=[CPS6263].[dbo].[v_getfactor" + yearid + "]&w=itid='" + itid + "' order by datepost desc";
    // console.log('url ' ,url)
    return this.http.get<any[]>(url);
  }

  // โหลดข้อมูลหัวข้อการแก้ไขแปลงอ้อยของ ผจก
  asktitle: any;
  loadTitle() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/SELECT_edit_type";
    return this.http.get<any[]>(url);
  };

  // บันทึกข้อมูลขอแก้ไขแปลงจาก ผจก.โซน
  saveAddRequestEditPlotManager(f: any) {
    let supcode = localStorage.getItem('supcode');
    let supzone = localStorage.getItem('supzone');
    let year = localStorage.getItem('yearCr');
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/insert_editDataCP?edit_type=" + f.edit_type
      + "&itid=%27" + f.itid + "%27"
      + "&year=" + year
      + "&comment=%27" + f.comment + "%27"
      + "&supzone=%27" + supzone + "%27"
      + "&supcode=%27" + supcode + "%27";
    return this.http.get<any[]>(url);
  }

  // โหลดข้อมูลรายการขอแก้ไขแปลงอ้อยของ ผจก
  listRequestEditPlotManager() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[v_editDataCP]&w=year='" + this.yearNow + "' and supzone='" + this.supzoneNow + "' order by date_add desc";
    return this.http.get<any[]>(url);
  };

  // โหลดข้อมูลหัวข้อการแก้ไขแปลงอ้อยของ ผจก.ส่วน
  listRequestEditPlotPart(partcode: string) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[v_editDataCP]&w=year='" + this.yearNow + "' and partcode='" + partcode + "' order by date_add desc";
    return this.http.get<any[]>(url);
  };

  searchFmcode(fmcode: string) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=fmname&f=[CPS6263].[dbo].[t_farmer]&w=fmcode_b1='" + fmcode + "'"
    return this.http.get<any[]>(url);
  }

  // บันทึกการแก้ไขเลขแปลง ของรายการเกี้ยว
  saveTransformFinance(f: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_getfactor?docid=" + f.s_docid + "&itid=" + f.hitid + "&intlandno=" + f.s_plot + "&fmcode=" + f.hfmcode + "&itremark=โอนเกี้ยวจากแปลง " + f.holdPlot;
    // console.log('url ' ,url)
    return this.http.get<any[]>(url);
  }

  // บันทึกการแก้ไขเลขแปลง ของรายการขอปัจจัยการผลิต
  saveTransformFactor(f: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_getfactor?docid=" + f.fac_docid + "&itid=" + f.fac_itid + "&intlandno=" + f.fac_intlandno + "&fmcode=" + f.fac_fmcode + "&itremark=โอนปัจจัยจากแปลง " + f.fac_oldPlot;
    // console.log('url ' ,url)
    return this.http.get<any[]>(url);
  }

  // รันหมายเลขแปลงถัดไปของชาวไร่ ในโซน ในปี ที่เลือก
  getNewlandno(year: string, f: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_function?s=dbo.getNewlandno('" + year + "','" + f.s_supzone + "','" + f.fb_edit_to + "') AS newLandno "
    // console.log('url: ' ,url)
    return this.http.get<any[]>(url)
  }

  // บาทต่อตันชาวไร่
  getBTFm(fmcode: string) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=fmcode_b1,btAll&f=[CPS6263].[dbo].[v_bt6566farmer]&w=fmcode_b1='" + fmcode + "'"
    // console.log('url: ' ,url)
    return this.http.get<any[]>(url)
  }

  // รายการขอสินเชื่อที่เลือก
  getFinanceSelect(docid: string, year: string) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[v_getfinance" + year + "]&w=docid=" + docid
    // console.log('url: ' ,url)
    return this.http.get<any[]>(url)
  }

  // รายการขอปัจจัยที่เลือก
  getFactorSelect(docid: string, year: string) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[v_getfactor" + year + "]&w=docid=" + docid
    // console.log('url: ' ,url)
    return this.http.get<any[]>(url)
  }

  // อัพเดตสถานะว่าแก้ไขแปลงแล้วที่ตาราง editDataCP
  updateEditPlotStatus1(edit_id: string) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/update_editDataCP_w?edit_ID=" + edit_id + "&edit_status=1"
    console.log('url: ', url)
    return this.http.get<any[]>(url)
  }

  // +++++++++++ ระบบบริหารจัดการพนักงาน BRD ++++++++++++++
  // ข้อมูลพนักงาน
  employeeList() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[v_employee]&w=1=1"
    return this.http.get<any[]>(url)
  }

  // ข้อมูลแผนก
  departmentList() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[v_department]&w=1=1"
    return this.http.get<any[]>(url)
  }

  // ข้อมูลส่วน
  brdpartList() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[partcode]&w=1=1"
    return this.http.get<any[]>(url)
  }

  // ข้อมูลฝ่าย
  brdfactionList() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[faction]&w=1=1"
    return this.http.get<any[]>(url)
  }

  // บันทึกการเพิ่มข้อมูลพนักงาน
  saveAddBrdEmp(f: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/insert_t_c_v?t=[CPS6263].[dbo].[employee]&c=dep_id,tname,fname,sname,nickname,idcard,emp_code,supcode,emp_type,birthday,contact,phone,lineid,faceid,email,dateStartBRR,dateStartBRD,education,imgurl,remark,positionName,positionLevel&v="
      + "'" + f.dep_id
      + "','" + f.tname
      + "','" + f.fname
      + "','" + f.sname
      + "','" + f.nickname
      + "','" + f.idcard
      + "','" + f.emp_code
      + "','" + f.supcode
      + "','" + f.emp_type
      + "','" + f.birthday
      + "','" + f.contact
      + "','" + f.phone
      + "','" + f.lineid
      + "','" + f.faceid
      + "','" + f.email
      + "','" + f.dateStartBRR
      + "','" + f.dateStartBRD
      + "','" + f.education
      + "','" + f.imgurl
      + "','" + f.remark
      + "','" + f.positionName
      + "','" + f.positionLevel
      + "'"
    console.log('url: ', url)
    return this.http.get<any[]>(url)
  }

  // บันทึกการเพิ่มข้อมูลแผนก
  saveAddBrdDep(f: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/insert_t_c_v?t=[CPS6263].[dbo].[department]&c=dep_id,dep_name,supzone,partcode,faction&v="
      + "'" + f.dep_id + "','" + f.dep_name + "','" + f.supzone + "','" + f.partcode + "','" + f.faction + "'"
    console.log('url: ', url)
    return this.http.get<any[]>(url)
  }

  // update Table department
  updateDepartment(f: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_department_w?dataid=" + f.dataid
      + "&dep_id=" + f.dep_id + "&dep_name=" + f.dep_name + "&partcode=" + f.partcode + "&faction=" + f.faction + "&supzone=" + f.supzone
    console.log('url: ', url)
    return this.http.get<any[]>(url)
  }

  // บันทึกการเพิ่มข้อมูลพนักงาน
  saveAddEmployee(f: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/insert_t_c_v?t=[CPS6263].[dbo].[employee]&c=emp_code,supcode,dep_id,tname,fname,sname,nickname,idcard,emp_type,birthday,contact,phone,lineid,faceid,email,dateStartBRR,dateStartBRD,education,remark&v="
      + "'" + f.emp_code + "','" + f.supcode + "','" + f.dep_id + "','" + f.tname + "'," + f.fname + "," + f.sname + "," + f.nickname + "," + f.idcard + "," + f.emp_type + "," + f.birthday + "," + f.contact + "," + f.phone + "," + f.lineid + "," + f.faceid + "," + f.email + "," + f.dateStartBRR + "," + f.dateStartBRD + "," + f.education + "," + f.remark
    console.log('url: ', url)
    return this.http.get<any[]>(url)
  }

  // ลบข้อมูลพนักงาน
  delEmp(dataid: string) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/delete_employee?dataid=" + dataid
    console.log('url: ', url)
    return this.http.get<any[]>(url)
  }

  // เก็บข้อมูลพนักงานที่ลบ
  addDelEmp(dataid: string) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/delete_employee?dataid=" + dataid
    console.log('url: ', url)
    return this.http.get<any[]>(url)
  }

  // จำนวนพนักงาน
  empSummary() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[v_empSummary]&w=1=1"
    // console.log('url: ', url)
    return this.http.get<any[]>(url)
  }

  // บันทึกการเพิ่มข้อมูลตำแหน่งงาน
  saveAddJob(f: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/insert_t_c_v?t=[CPS6263].[dbo].[brdJobTitle]&"
      + "c=jobName,jobResponsive,educational,fieldStudy,dep_id"
      + "&v=" + "'" + f.jobName + "','" + f.jobResponsive + "','" + f.educational + "','" + f.fieldStudy + "'," + f.dep_id
    console.log('url: ', url)
    return this.http.get<any[]>(url)
  }

  // แสดงข้อมูลตำแหน่ง
  jobtitleList() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[v_brdjobtitle]&w=1=1"
    // console.log('url: ', url)
    return this.http.get<any[]>(url)
  }

  // แสดงข้อมูลฝ่าย
  factionList() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[faction]&w=1=1"
    // console.log('url: ', url)
    return this.http.get<any[]>(url)
  }

  // แสดงข้อมูลส่วน
  partList() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[partcode]&w=1=1"
    // console.log('url: ', url)
    return this.http.get<any[]>(url)
  }

  // บันทึกการเพิ่มข้อมูลฝ่าย
  saveAddFaction(f: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/insert_t_c_v?t=[CPS6263].[dbo].[faction]&c=faction,faction_name&v="
      + "'" + f.faction
      + "','" + f.faction_name + "'"
    return this.http.get<any[]>(url)
  }

  // update Table faction
  updateFaction(f: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_faction_w?dataid=" + f.dataid
      + "&faction=" + f.faction + "&faction_name=" + f.faction_name
    console.log('url: ', url)
    return this.http.get<any[]>(url)
  }

  // update Table brdjobtitle
  updateJob(f: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_t_s_w?t=[CPS6263].[dbo].[brdjobtitle]&s=dep_id="
      + f.dep_id + ",jobName='" + f.jobName + "',jobResponsive='" + f.jobResponsive + "',educational='" + f.educational
      + "',fieldStudy='" + f.fieldStudy + "'&w=dataid=" + f.dataid
    console.log('url: ', url)
    return this.http.get<any[]>(url)
  }

  // บันทึกการเพิ่มข้อมูลส่วน
  saveAddPart(f: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/insert_t_c_v?t=[CPS6263].[dbo].[partcode]&c=partcode,partname&v="
      + "'" + f.partcode
      + "','" + f.partname + "'"
    return this.http.get<any[]>(url)
  }

  // ลบข้อมูลฝ่าย
  delFaction(dataid: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/delete_t_w?t=[CPS6263].[dbo].[faction]&w=dataid=" + dataid
    return this.http.get<any[]>(url)
  }

  // ลบข้อมูลส่วน
  delPart(dataid: number) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/delete_t_w?t=[CPS6263].[dbo].[partcode]&w=dataid=" + dataid
    // console.log('url :', url)
    return this.http.get<any[]>(url)
  }

  // update Table partcode
  updatePart(f: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/update_t_s_w?t=[CPS6263].[dbo].[partcode]&s=partcode="
      + "'" + f.partcode + "',partname='" + f.partname + "'&w=dataid=" + f.dataid
    // console.log('url: ', url)
    return this.http.get<any[]>(url)
  }

  // ++++ BRD Dashboard ++++

  // ติดตามกิจกรรมแปลงที่เป็น KPI
  getKpiMonitor(year: string) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_kpiActivityMonitor_" + year + "]&w=1=1"
    return this.http.get<any[]>(url)
  }

  // ข้อมูลการประเมินอ้อยและจัดกลุ่ม ในปีการผลิต v_Assess_xxxx
  loadEstimateCaneData(year: string) {
    let url = "s=*&f=[CPS6263].[dbo].[v_Assess_" + year + "]&w=1=1"
    url = this.baseSelectUrl2 + url
    return this.http.get<any[]>(url)
  }

  // ข้อมูล สัดส่วนพันธุ์อ้อย
  loadSeedcaneRatioData(year: string) {
    let url = "s=*&f=[CPS6263].[dbo].[v_seed_group]&w=year=" + year + ""
    url = this.baseSelectUrl2 + url
    return this.http.get<any[]>(url)
  }

  // ข้อมูล การอัพเดตกิจกรรมแปลง
  getCpupdateData(year: string) {
    let url = `s=FORMAT(lastupdate, 'yy-MM')'yedate',FORMAT(lastupdate, 'MMMM', 'th-TH') as 'mupdate',COUNT(*) cntPlot&"
      f=[CPS6263].[dbo].[v_cp${year}_basic]&
      w=caneage > 0 and lastupdate is not null group by FORMAT(lastupdate, 'yy-MM'),FORMAT(lastupdate, 'MMMM', 'th-TH')`
    url = this.baseSelectUrl2 + url
    return this.http.get<any[]>(url)
  }

  // ข้อมูล การอัพเดตกิจกรรมแปลงในแต่ละวันของเดือน
  getCpupdateDiaryData(year: string) {
    let url = "s=CONVERT(date,lastupdate) datedata,format(lastupdate,'dd','en') datem,COUNT(*) cntPlot&"
      + "f=[CPS6263].[dbo].[v_cp" + year + "_basic]&"
      + "w=MONTH(lastupdate) = MONTH(getdate()) group by CONVERT(date,lastupdate),format(lastupdate,'dd','en') order by datem"
    url = this.baseSelectUrl2 + url
    return this.http.get<any[]>(url)
  }

  // BRR Summary ประวัติต่างๆของอ้อยบริษัท
  getBrrsummary() {
    let url = "s=*&f=[cps6263].[dbo].[brrsummary]&w=1=1"
    url = this.baseSelectUrl2 + url
    return this.http.get<any[]>(url)
  }

  // พื้นที่ปลูก ปริมาณอ้อย ผลผลิต
  summaryBRD(year: string) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w_0?s=*&f=[CPS6263].[dbo].[v_sumTargetCane]&w=year=" + year
    // console.log('url: ', url)
    return this.http.get<any[]>(url)
  }

  // พื้นที่ปลูก ปริมาณอ้อย ผลผลิต แยกตามประเภทอ้อย
  summaryBRD_canetype() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=*&f=[CPS6263].[dbo].[v_sumCanetype6566]&w=1=1"
    // console.log('url: ', url)
    return this.http.get<any[]>(url)
  }

  // พื้นที่ปลูก ปริมาณอ้อย ผลผลิต แยกตามระดับพื้นที่
  summaryBRD_areaLevel() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=Arealevel, sum(landvalue_left) area, sum(Assess_left) asNow, Round(sum(Assess_left)/10000,2) asNowShort, round(sum(Assess_left)/sum(landvalue_left),2) yieldNow &f=[CPS6263].[dbo].[v_cp6566_basic] &w=Arealevel is not null  group by Arealevel"
    // console.log('url: ', url)
    return this.http.get<any[]>(url)
  }

  // พื้นที่ปลูก ประเมินอ้อย รายวัน
  summaryBRD_trendAssess() {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/select_s_f_w?s=convert(date,lastupdate) dataDate,partcode,landvalueTon,assess,Round(assess/100000,2) assessShort&f=[dbTemp].[dbo].[vw_informarea6566] &w=partcode='BRD' order by dataDate"
    // console.log('url: ', url)
    return this.http.get<any[]>(url)
  }

  // การจัดกลุ่มคิวอ้อย
  getCpgroupQ(year: string) {
    let url = this.baseSelectUrl2
      + "s=qtype,isnull(qdesc,'ยังไม่จัดกลุ่ม')qdesc,SUM(assess) assess"
      + "&f=cps6263.dbo.v_cp" + year + "_basic"
      + "&w=growed1='Y'/*(qtype)!='0'*/ group by qtype,qdesc order by qtype"
    return this.http.get<any[]>(url)
  }


  // ข้อมูลสรุปเกี้ยวในขั้นตอนต่างๆ
  getFinanceSummary() {
    let url = this.baseSelectUrl + "s=*&t=v_monitorFinanceSupcode6667&w=1=1"
    return this.http.get<any[]>(url)
  }

  // +++++++++++++++++++++ ระบบฝากหัก +++++++++++++++++++++++++++++++++++++
  // ตรวจสอบว่าสามารถทำรายการฝากหักได้หรือไม่
  ckCanDeposit() {
    let url = this.baseSelectUrl
      + "s=*&f=dbQBRD.dbo.v_setup&w=1=1"
    return this.http.get<any[]>(url)
  }

  //ข้อมลการส่งอ้อยตามเงื่อนไขที่เลือก
  getCpcData(f: any) {
    //let sqlTable = "s=*&f=dbQBRD.dbo.cpc_deposit_carcut"
    //let sqlTable = "s=*&f=dbPayment.dbo.cpc_depositcane_report"
    let userWhere = "", sw = '';
    let usercontent = f.scontent
    switch (usercontent) {
      case "1": sw = "cut_no"; break;
      case "2": sw = "OWNCODE"; break;
      case "3": sw = "FMCODE"; break;
      case "4": sw = "groupcodeQ"; break;
      case "5": sw = "REGTRUCK"; break;
      case "6": sw = "KEEP_NO"; break;
      default: sw = "cut_no"; break;
    }
    userWhere = `${sw}='${f.xsearch.trim()}'and[reportdate]between'${f.datefrom}'and'${f.dateto}'order by[reportdate],[fmcode]`
    //const url = this.baseSelectUrl3 + sqlTable + userWhere;
    let url = `${this.hurl}function-1/select_sfw_0`
    const params = {
      s: '*',
      f: `dbPayment.dbo.cpc_depositcane_report`,
      w: userWhere
    };
    // console.log('url ' ,url)
    return this.http.get<any[]>(url, { params })
  }

  // บันทึกการฝากหัก
  saveDeposit(f: any) {
    let supcode: string = localStorage.getItem('supcode')
    let url = ""
    let sqlSet = ""
    let sqlWhere = "&w=truck_q='" + f.truck_q + "'"
    let cutmethod = f.cutmethod
    if (cutmethod == "C") {
      sqlSet = "s=owncode='" + f.owncode + "',truck_fee=" + f.truck_fee + ",owncode_cut='" + f.owncodecut + "',cut_rate=" + f.cut_rate + ",userzone='" + supcode + "',DateUpdateZone = getdate()"
    } else {
      sqlSet = "s=owncode='" + f.owncode + "',truck_fee=" + f.truck_fee + ",owncode_keep='" + f.Owncode_keep + "',keep_rate=" + f.keep_rate + ",userzone='" + supcode + "',DateUpdateZone = getdate()"
    }
    url = this.baseUpdateUrl + "t=dbQBRD.dbo.cpc_truc&" + sqlSet + sqlWhere
    console.log('url ', url)
    return this.http.get<any[]>(url)
  }

  // +++++++++++++++ ระบบเบิกน้ำมัน ++++++++++++++++++++++++
  getGroupSelect(x: string) {
    let url = ""
    let sql = ""
    switch (x) {
      case "1": // รถตัด
        sql = "s=carcutId as carcode,groupcode,h_fmname fmname,carReg as regcar&t=vw_carcut&w=1=1 order by fmname,carReg"
        break;
      case "2": // รถคีบ
        sql = "s=keep_no as carcode,owncode_keep fmcode,fmname,groupcode,keep_no as regcar&t=dbQBRD.dbo.Car_keep&w=dataok='1' order by fmname,keep_no"
        break;
      default:
        sql = "s=carcutId as carcode,groupcode,h_fmname fmname,carReg as regcar&t=vw_carcut&w=1=1 order by fmname,carReg"
        break;
    }
    url = this.baseSelectUrl2 + sql
    return this.http.get<any[]>(url)
  }

  getPeriod_cane() {
    let url = this.baseSelectUrl + "s=period_cane&t=dbQBRD.dbo.v_qcard6566&w=1=1 group by period_cane order by period_cane desc"
    return this.http.get<any[]>(url)
  }

  // ตรวจสอบการเบิกน้ำมันในงวดของรถตัด รถคีบ
  getOilpayed(f: any) {
    let url = ""
    let sql = ""
    switch (f.oil_type) {
      case "1": // รถตัด
        sql = `s=*,'${f.period_cane}'as period_cane&t=dbQBRD.dbo.fnc_carcutgetoil('${f.carcode}','${f.period_cane}')&w=1=1`
        break;
      case "2": // รถคีบ
        sql = `s=*,'${f.period_cane}'as period_cane&t=dbQBRD.dbo.fnc_carkeepgetoil('${f.carcode}','${f.period_cane}')&w=1=1`
        break;
      default:
        sql = `s=*,'${f.period_cane}'as period_cane&t=dbQBRD.dbo.fnc_carcutgetoil('${f.carcode}','${f.period_cane}')&w=1=1`
        break;
    }
    url = this.baseSelectUrl2 + sql
    return this.http.get<any[]>(url)
  }

  // รายละเเอียดการเบิกน้ำมันในงวดของรถตัด รถคีบ
  getOilpayedList(f: any) {
    //let y = localStorage.getItem('yearCr')
    let sql = ""
    switch (f.oil_type) {
      case "1": // รถตัด
        sql = "s=t1.*,t2.fmcode,t2.fmname,t2.carReg,t3.supname,t3.zonedata as supzone"
          + "&t=oilpay t1 left join vw_carcut t2 on t1.carcode = t2.carcutid left join dbcps.dbo.users t3 on t1.usercode = t3.supcode"
          + "&w=t1.yearid='" + f.yearid + "' and t1.carcode='" + f.carcode + "' and t1.period_cane='" + f.period_cane + "' and t1.doc_status='1' order by t1.datepost desc"
        break;
      case "2": // รถคีบ
        sql = "s=t1.*,t2.Owncode_keep fmcode,t2.fmname,t2.keep_no carReg,t3.supname,t3.zonedata as supzone"
          + "&t=oilpay t1 left join dbqbrd.dbo.v_Car_keep t2 on t1.carcode = t2.Keep_no left join dbcps.dbo.users t3 on t1.usercode = t3.supcode"
          + "&w=t1.yearid='" + f.yearid + "' and t1.carcode='" + f.carcode + "' and t1.period_cane='" + f.period_cane + "' and t1.doc_status='1' order by t1.datepost desc"
        break;
    }
    const url = this.baseSelectUrl2 + sql
    return this.http.get<any[]>(url)
  }

  // เพิ่มข้อมูลการเบิกน้ำมัน
  saveAddOilPay(f: any) {
    let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbcps/insert_t_c_v?"
      + "t=[CPS6263].[dbo].[oilpay]&c=yearid,oil_type,carcode,groupcode,period_cane,oil_amount,usercode,doc_status,remark&"
      + "v=" + "'" + f.yearid + "','" + f.oil_type + "','" + f.carcode.trim() + "','" + f.groupcode + "','" + f.period_cane + "'," + f.oil_amount + ",'" + f.usercode + "','1','" + f.remark + "'"
    console.log('url ', url)
    return this.http.get<any[]>(url)
  }

  // โครงการต่าง ที่สนับสนุนการเพิ่มผลผลิตอ้อย BRD project support
  getProjectSupport(yearid: string) {
    let url = this.baseSelectUrl
      + "s=*&t=CPS6263.dbo.vw_brdProject&w=yearid='" + yearid + "'"
    return this.http.get<any[]>(url)
  }

  // เชคปีการผลิต สำหรับใช้กับพวก label year ตามหน้าเวบ
  getYearActive() {
    let url = this.baseSelectUrl
      + "s=*"
      + "&f=dbqbrd.dbo.setup"
      + "&w=1=1"
    return this.http.get<any[]>(url);
  }

  // ข้อมูลรายงานประจำวันฤดูหีบอ้อย ฝ่ายจัดหาวัตถุดิบ
  getBrdCPCDiaryReport(date: string): Observable<any> {
    let url = this.baseSelectUrl
      + "s=*"
      + "&f=cps6263.dbo.fnc_CpcDiaryReportBRD('" + date + "')"
      // + "&f=cps6263.dbo.fnc_CpcDiaryReportBRD"
      + "&w=1=1"
    return this.http.get<any[]>(url).pipe(
      retry(3),
      catchError(error => {
        console.error('Error occurred:', error);
        return throwError(() => new Error('Fail to fetch data'));
      })
    );
  }

  // ข้อมูลรายงานประจำวันฤดูหีบอ้อย ฝ่ายจัดหาวัตถุดิบ
  getBrdCPCDiaryReportData(date: string): Observable<any> {
    let url = this.baseSelectUrl
      + "s=*"
      + "&f=cps6263.dbo.brdCPCDiaryReport"
      + "&w=reportdate='" + date + "'"
    return this.http.get<any[]>(url).pipe(
      retry(3),
      catchError(error => {
        console.error('Error occurred:', error);
        return throwError(() => new Error('Fail to fetch data'));
      })
    );
  }

  // ข้อมูลรายงานประจำวันฤดูหีบอ้อย นักส่งเสริม เขต ส่วน
  getSupervisCPCDiaryReport(date: string, supcode: string): Observable<any> {
    let url = this.baseSelectUrl
      + "s=*"
      + "&f=cps6263.dbo.fnc_CpcDiaryReport_Supervis('" + date + "','" + supcode + "')"
      // + "&f=cps6263.dbo.supervisCPCDiaryReport"
      // + "&w=reportdate = '"+date+"' and supcode='"+supcode+"'"
      + "&w=1=1"
    return this.http.get<any[]>(url).pipe(
      retry(3),
      catchError(error => {
        console.error('Error occurred:', error);
        return throwError(() => new Error('Fail to fetch data'));
      })
    );
  }

  // ใช้ shareReplay เพื่อ Cache คำขอ API
  getCachedDataBrdCPCDiaryReport(date: string): Observable<any> {
    let url = this.baseSelectUrl
      + "s=*"
      + "&f=dbqbrd.dbo.fnc_brdCPCDiaryReport('" + date + "')"
      + "&w=1=1"
    // if(!this.cachedbrdCPCData$) {
    //   this.cachedbrdCPCData$ = this.http.get(url).pipe(
    //     shareReplay(1)  // Cache ค่าไว้สำหรับผู้ Subscribe คนต่อไป
    //   );
    // }
    // return this.cachedbrdCPCData$;
    return this.http.get(url);
  }

  // ใช้ shareReplay เพื่อ Cache คำขอ API
  saveUpdateCpcDiaryReport(f): Observable<any> {
    let url = this.baseUpdateUrl
      + "t=CPS6263.dbo.brdCPCDiaryReport"
      + "&s=trash_today_brr=" + f.trash_today_brr + ",trash_brr=" + f.trash_brr
      + ",sugarperccs_today_brr=" + f.sugarperccs_today_brr + ",sugarperccs_brr=" + f.sugarperccs_brr
      + ",sugarperton_today_brr=" + f.sugarperton_today_brr + ",sugarperton_brr=" + f.sugarperton_brr
      + ",outstandingDebt_target=" + f.outstandingDebt_target + ",outstandingDebt_today=" + f.outstandingDebt_today + ",outstandingDebt_amount=" + f.outstandingDebt_amount
      + ",lossCutting_target=" + f.lossCutting_target + ",lossCutting=" + f.lossCutting
      + "&w=id=" + f.id
    return this.http.get(url);
  }

  searchRegtruck_canequality(year: string, regtruck: string): Observable<any> {
    let url = this.baseSelectUrl
      + "s=*"
      + "&f=dbqbrd.dbo.fnc_searchRegtruck_canequality_" + year + "('" + regtruck + "')"
      + "&w=1=1 order by booktime desc"
    return this.http.get(url);
  }

  productionyear(): Observable<any> {
    let url = this.baseSelectUrl
      + "s=*"
      + "&f=dbintechgen3.dbo.production_years"
      + "&w=1=1"
    if (!this.cachedProductionYearData$) {
      this.cachedProductionYearData$ = this.http.get(url).pipe(
        shareReplay(1)  // Cache ค่าไว้สำหรับผู้ Subscribe คนต่อไป
      );
    }
    return this.cachedProductionYearData$;
  }

  // เพิ่มข้อมูลอ้อยไม่ได้คุณภาพ หน้าห้องคิว
  saveCaneQuality(f: any) {
    const url = this.baseInsertUrl
      + "t=dbQBRD.dbo.cane_quality_list"
      + "&c=production_year_id,truck_q,user_id,contaminants,details,imageUrl,doc_status"
      + "&v=" + f.production_year_id + ",'" + f.truck_q + "'," + f.user_id + ",'" + f.contaminants + "','" + f.details + "','" + f.imageUrl + "'," + f.doc_status
    // console.log('url: ', url)
    return this.http.get(url);
  }

  // แสดงข้อมูลคุณภาพอ้อย
  getCanequalityData(date) {
    let url = this.baseSelectUrl
      + "s=*"
      + "&f=dbQBRD.dbo.v_canequality"
      + "&w=convert(date ,created_at)='" + date + "' order by created_at desc"
    // if(!this.cachedCanequalityData$) {
    //   this.cachedCanequalityData$ = this.http.get(url).pipe(
    //     shareReplay(1)  // Cache ค่าไว้สำหรับผู้ Subscribe คนต่อไป
    //   );
    // }
    // return this.cachedCanequalityData$;
    return this.http.get(url);
  }

  // แสดงข้อมูลคุณภาพอ้อยทั้งหมดของปี
  getAllCanequalityData(year: string) {
    let url = this.baseSelectUrl2
      + "s=*"
      + "&f=dbQBRD.dbo.v_canequality"
      + "&w=yearID='" + year + "' order by created_at desc"
    return axios.get(url)
  }

  // update การแก้ไขปัญหาอ้อยไม่ได้คุณภาพที่ตรวจพบของ นอส.
  saveCorrectionSupcode(id: number, t: string) {
    let url = this.baseUpdateUrl
      + "t=dbQBRD.dbo.cane_quality_list"
      + "&s=correction='" + t + "'"
      + "&w=id=" + id
    return axios.get(url)
  }

}
